import type { SVGProps } from 'react';

const ColumnVisibilityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={13}
    height={10}
    viewBox='0 0 13 10'
    fill='none'
    {...props}>
    <path
      fill='#696F88'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 9.75V0H12.75V9.75H0ZM7.5 8.25V1.5H5.25V8.25H7.5ZM1.5 1.5H3.75V8.25H1.5V1.5ZM9 8.25H11.25V1.5H9V8.25Z'
    />
  </svg>
);

export default ColumnVisibilityIcon;
